import type { Promotion } from '../Promotions.types'
import { isPromotionMembershipsSingle } from './isPromotionMembershipsSingle'
import { isPromotionSingle } from './isPromotionSingle'

export const getPromotionTitle = (promotionData?: Promotion): string => {
  if (promotionData) {
    return isPromotionSingle(promotionData) || isPromotionMembershipsSingle(promotionData)
      ? promotionData.code
      : promotionData.title
  }

  return ''
}
